import { render, staticRenderFns } from "./ModalDeleteService.vue?vue&type=template&id=295b3a63&scoped=true"
import script from "./ModalDeleteService.vue?vue&type=script&lang=js"
export * from "./ModalDeleteService.vue?vue&type=script&lang=js"
import style0 from "./ModalDeleteService.vue?vue&type=style&index=0&id=295b3a63&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295b3a63",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDialog,VIcon})
